(function () {
  function buildSuccessMessage(template, name) {
    const safeName = (name || '').trim() || 'friend';
    return template.replace(/%Name%/g, safeName);
  }

  function initStoryPopups() {
    const popups = Array.from(document.querySelectorAll('[data-story-popup]'));
    if (!popups.length) return;

    popups.forEach((popup) => {
      if (popup.dataset.storyPopupReady === 'true') return;
      popup.dataset.storyPopupReady = 'true';

      const popupId = popup.id;
      const dialog = popup.querySelector('.story-popup__dialog');
      const shell = popup.querySelector('[data-story-popup-shell]');
      const form = popup.querySelector('form');
      const submit = popup.querySelector('[data-story-popup-submit]');
      const errorBox = popup.querySelector('[data-story-popup-error]');
      const successView = popup.querySelector('[data-story-popup-success-view]');
      const formView = popup.querySelector('[data-story-popup-form-view]');
      const successMessage = popup.querySelector('[data-story-popup-success-message]');
      const nameInput = popup.querySelector('input[name="contact[first_name]"]');
      const successTemplate = shell?.dataset.successTemplate || '';
      const storedNameKey = 'story-popup-name:' + popupId;

      function openPopup() {
        popup.hidden = false;
        popup.classList.add('is-open');
        popup.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('story-popup-open');
        window.setTimeout(() => {
          (nameInput || dialog).focus();
        }, 0);
      }

      function closePopup() {
        popup.classList.remove('is-open');
        popup.setAttribute('aria-hidden', 'true');
        popup.hidden = true;
        document.documentElement.classList.remove('story-popup-open');
      }

      function showError(message) {
        if (!errorBox) return;
        errorBox.textContent = message;
        errorBox.hidden = false;
      }

      function clearError() {
        if (!errorBox) return;
        errorBox.hidden = true;
        errorBox.textContent = '';
      }

      function showSuccess(name) {
        if (successMessage) {
          successMessage.textContent = buildSuccessMessage(successTemplate, name);
        }
        if (formView) formView.hidden = true;
        if (successView) successView.hidden = false;
        clearError();
      }

      document.querySelectorAll('[data-story-popup-open][data-story-popup-target="' + popupId + '"]').forEach((trigger) => {
        trigger.addEventListener('click', openPopup);
      });

      popup.querySelectorAll('[data-story-popup-close]').forEach((closeTrigger) => {
        closeTrigger.addEventListener('click', closePopup);
      });

      popup.addEventListener('click', function (event) {
        if (event.target === popup.querySelector('.story-popup__backdrop')) {
          closePopup();
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && popup.classList.contains('is-open')) {
          closePopup();
        }
      });

      if (!form) return;

      if (shell?.dataset.postedSuccessfully === 'true') {
        const storedName = window.sessionStorage.getItem(storedNameKey) || nameInput?.value || '';
        window.sessionStorage.removeItem(storedNameKey);
        openPopup();
        showSuccess(storedName);
      } else if (errorBox && !errorBox.hidden && errorBox.textContent.trim() !== '') {
        openPopup();
      }

      form.addEventListener('submit', function (event) {
        clearError();

        if (!form.reportValidity()) {
          event.preventDefault();
          return;
        }
        const currentName = nameInput?.value || '';
        window.sessionStorage.setItem(storedNameKey, currentName);

        if (submit) {
          submit.disabled = true;
          submit.dataset.originalLabel = submit.textContent;
          submit.textContent = 'Sending...';
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStoryPopups);
  } else {
    initStoryPopups();
  }

  document.addEventListener('shopify:section:load', initStoryPopups);
})();